// import React from 'react';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
//   Legend,
// } from 'recharts';
// import { Paper, Typography, Box } from '@mui/material';
 
// // Function to generate random colors
// const generateRandomColors = (length) =>
//   Array.from(
//     { length },
//     () =>
//       `#${Math.floor(Math.random() * 16777215)
//         .toString(16)
//         .padStart(6, '0')}`
//   );
 
// const Barchart = ({ data, title, colors, keys,height }) => {
//   // Use provided colors or generate random ones based on keys length
//   const chartColors = colors?.length
//     ? colors
//     : generateRandomColors(keys.length);
 
//   return (
//     <Paper sx={{ padding: 2, textAlign: 'center' }}>
//       <Typography variant="h6" sx={{ marginBottom: 2 ,color:'#000'}}>
//         {title}
//       </Typography>
//       <Box sx={{ width: '100%', height: height }}>
//         <ResponsiveContainer>
//           <BarChart
//             data={data}
//             margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
//           >
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey="name" />
//             <YAxis />
//             <Tooltip />
//             <Legend />
//             {keys.map((key, index) => (
//               <Bar
//                 key={key}
//                 dataKey={key}
//                 fill={chartColors[index]}
//                 barSize={40}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Box>
//     </Paper>
//   );
// };
 
// export default Barchart;
 
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from 'recharts';
import { Paper, Typography, Box } from '@mui/material';

// Function to generate random colors
const generateRandomColors = (length) =>
  Array.from(
    { length },
    () =>
      `#${Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')}`
  );

const Barchart = ({ data, title, colors, keys, height }) => {
  const chartColors = colors?.length ? colors : generateRandomColors(keys.length);
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <Paper sx={{ p: 2, borderRadius: 2, display: "flex", flexDirection: "column", boxShadow:"0px 0px 10px 0px #0000001A" }}>
      <Typography variant="h6" sx={{ marginBottom: 2, color: '#000' }}>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: height }}>
      {hasData ? (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart
      data={data}
      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      barCategoryGap="20%"
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" style={{ fontSize: 14 }} />
      <YAxis style={{ fontSize: 14 }} />
      <Tooltip />
      <Legend wrapperStyle={{ fontSize: 14 }} />
      {keys.map((key, index) => (
        <Bar key={key} dataKey={key} fill={chartColors[index]} barSize={30} />
      ))}
    </BarChart>
  </ResponsiveContainer>
) : (
  <Typography variant="body1" color="textSecondary">
    No data found
  </Typography>
)}

    </Box>
  </Paper>
  );
};

export default Barchart;
